// extracted by mini-css-extract-plugin
module.exports = {"error":"else_error__3r4vP","text1":"else_text1__HFZ9n"};